<template>
  <InstalarPantalla :open="open" tema="meseros" titulo="App de meseros" icono="mdi-silverware-fork-knife"
    subtitulo="Elige la sucursal donde tomarás los pedidos.">
    <div :key="key">
      <ng-select-options v-model="item.bus_subsidiary_id" label="Sucursal" :rules="{ required: true }"
        :items="subsidiaries" :filled="false" :dense="false"></ng-select-options>
    </div>

    <template #acciones="{ invalid }">
      <v-btn block large color="success" elevation="0" @click="install" :loading="loading"
        :disabled="invalid || loading">
        {{ $t("install") }}
      </v-btn>
      <v-btn block text class="mt-2" @click="$store.dispatch('logoutAuth')">
        <v-icon small left>mdi-logout-variant</v-icon> {{ $t("logout") }}
      </v-btn>
    </template>
  </InstalarPantalla>
</template>
  <script>
import InstalarPantalla from "@/components/base/InstalarPantalla.vue";
  import localAgent from '@/plugins/local-agent.js'
  import appUtil from "@/plugins/app-utils.js";
  
  export default {
    name: "Install",
    components: { InstalarPantalla },
    props: ["open"],
    data: () => ({
      dialog: true,
      key: 0,
      subsidiaries: [],
      cashResgisters: [],
      item: { bus_subsidiary_id: null, bill_cash_register_id: null },
      agent: false,
      backup: false,
      loading: false
    }),
    mounted() {
      this.loadSubsidiaries();
  
    },
    methods: {
      changeLocationHref(){
        appUtil.changeLocationHref()
      },
      async restore() {
        this.loading = true
        let ok = await localAgent.restore(this.$db)
  
        setTimeout(() => {
          this.loading = false
          this.changeLocationHref();
        }, 5000)
  
      },

      install() {
        this.$http
          .post(
            "api/v1/subsidiary/pos-install",
            this.item,
            true,
            true
          )
          .then(async (response) => {
            if (response.success) {
              await this.$db.install(response.config);
  
              const inst = await this.$db.getInstallation();
  
  
              setTimeout(() => {
                let txt = this.$db.serialize();
                localAgent.save(txt)
              }, 500)
  
              this.$emit("installed");
            }
          });
      },
      changeSubsidiary(evt) {
        if (evt) {
          this.$http
            .get(
              "api/v1/cash-register",
              {
                 subsidiary: [{ id: evt.id,  }], 'installed': false,
                _paginate: { page: 1, max_rows: 100 },
                _order: [{ field: "name", direction: "asc" }],
              },
              true,
              true
            )
            .then((response) => {
              if (response.success) {
                this.cashResgisters = response.items;
                //this.key++;
              }
            });
        } else {
          this.cashResgisters = [];
        }
      },
  
      loadSubsidiaries() {
        this.$http.get('api/v1/lists/subsidiary', { '_order': [{ field: "name", direction: "asc" }] })
  
          .then((response) => {
            if (response.success) {
              this.subsidiaries = response.items;
              this.key++;
            }
          });
      },
    },
  };
  </script>
  